export class UserDisabledError extends Error {
  public constructor() {
    super()

    this.message = 'errors.userDisabled'
  }
}
